module.exports = __webpack_public_path__ + "static/media/edb-back.a4fe1073.png";